import { isNil } from 'lodash';
import { MeasurementUnitCodesEnum } from '../../../../common/models/unit-system.model';
import { NOT_AVAILABLE } from '../../../../common/constants/template.constant';

export class ShipmentTransportOrderOuterPackagesModel {
  grossWeight: number;
  height: number;
  length: number;
  piecesCount: number;
  typeOfHU: string;
  volume: number;
  width: number;

  get dimensions(): string {
    return `${isNil(this.length) ? NOT_AVAILABLE : this.length} x ${isNil(this.width) ? NOT_AVAILABLE : this.width} x ${
      isNil(this.height) ? NOT_AVAILABLE : this.height
    }`;
  }

  constructor(params?: ShipmentTransportOrderOuterPackagesModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface ShipmentTransportOrderOuterPackagesResponseModel {
  items: ShipmentTransportOrderOuterPackagesModel[];
  dimensionsUnitCode: MeasurementUnitCodesEnum;
  weightUnitCode: MeasurementUnitCodesEnum;
  volumeUnitCode: MeasurementUnitCodesEnum;
}
